/* import __COLOCATED_TEMPLATE__ from './notification-preference-item.hbs'; */
import { Promise } from 'rsvp';
import Component from '@ember/component';
import { NOTIFICATION_PREFERENCE } from '../../models/notification-preference';
import { showModal } from "sh-www/utils/modal-controls";
import { inject as service } from '@ember/service';

const NotificationPreferenceItem = Component.extend({
  classNames: ['preference-item'],

  store: service(),
  notificationPreferenceCommands: service('commands.notification-preference-commands'),

  /**
   * True while transitioning to either off or on
   *
   * Passed in from parent
   *
   * @type {bool}
   */
  isTransitioning: false,

  /**
   * Passed in from parent when we need to require dates for this preference.
   *
   * @type {bool}
   */
  isRequiresDates: false,

  startAt: undefined,
  endAt: undefined,

  actions: {
    /**
     * Called when the email preference toggle is clicked
     *
     * @param {NotificationPreference} preference
     * @param {Object.<checked>} checkBox
     * @param {Function} resetSwitch
     */
    onPreferenceChanged: function(preference, checkBox, resetSwitch) {
      let isTransitioning = this.get('isTransitioning');
      if (isTransitioning) {
        return;
      }

      this.set('isTransitioning', true);
      const status = checkBox.checked ? NOTIFICATION_PREFERENCE.STATUSES.ON : NOTIFICATION_PREFERENCE.STATUSES.OFF;

      if (status === NOTIFICATION_PREFERENCE.STATUSES.ON) {
        //always reset start and end dates when user turn the preference off
        this.startAt = null;
        this.endAt = null;
      }

      this.notificationPreferenceCommands.update(preference, {
        status,
        startAt: this.startAt,
        endAt: this.endAt,
      }).then((response) => {
        this.store.pushPayload(response);
        this.model = this.store.peekRecord('device', response.data.id);
      }).catch(() => {
        let modalData = {
          titleText: 'Error saving your setting.',
          bodyText: 'Please try again.',
          actionButtonText: 'OK'
        };
        showModal(this, 'alert', modalData);
      }).finally(() => {
        this.set('isTransitioning', false);
      });
    },

    /**
     * This function will return a Promise that will resolve with the start and end dates
     * that should be supplied by the JobOpportunitiesDateSelectionModal.
     *
     * OnSuccess:   .then(function(startDate, endDate))
     * OnFailure:   .catch()      // Dates were not supplied by the user in this case.
     *
     * @returns {Promise}
     */
    checkDates: function() {
      let pref = this.get('preference'),
        isRequiresDates = this.get('isRequiresDates');

      if (!isRequiresDates) {
        // we don't need to check dates, let's just resolve true.
        return Promise.resolve(true);
      }

      if (pref.get('isStatusOff')) {
        // if status is already off, we don't need to verify, so let's accept it.
        return Promise.resolve(true);
      }

      let checkDatesPromise = new Promise((resolve, reject) => {
        var modalModel = {
          timeframe: this.get('preference'),
          resolveDates: resolve,
          rejectDates: reject,
          dateSelectionTitle: 'Turn Off Job Opportunities',
          dateSelectionBody: 'This will remove you from search, and you will not receive any job opportunity notifications until you re-enable this setting!',
          dateSelectionConfirmationTitle: 'Are you sure you do not want to be notified about any jobs?',
          dateSelectionConfirmationBody: 'This will take you out of all Glimmer freelancer job searches.',
          isShowConfirmation: true
        };

        showModal(this, 'date-selection', modalModel);
      });

      checkDatesPromise.then(([startDate, endDate]) => {
        this.startAt = startDate;
        this.endAt = endDate;
      }).catch(() => { /* nothing to do here. User cancelled the date selection */});

      return checkDatesPromise;
    }
  }
});

export default NotificationPreferenceItem;
